import { Container, Row } from "reactstrap";
import { GoogleMapTitle, MapTitle } from "../../../../constants";
import BasicMap from "./BasicMap";
import MarkerMaps from './MarkerMaps';
import PolygonsMap from './PolygonsMap';
import PolylineMaps from './PolylineMaps';
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const GoogleMapsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={GoogleMapTitle} parent={MapTitle} />
      <Container fluid>
        <Row>
          <BasicMap />
          <MarkerMaps/>
          <PolygonsMap/>
          <PolylineMaps/>
        </Row>
      </Container>
    </>
  );
};
export default GoogleMapsContainer;
